{
    "Accessibility menu": "அணுகல் மெனு",
    "Close": "மூடு",
    "Content adjustments": "உள்ளடக்க சரிசெய்தல்கள்",
    "Navigation adjustments": "வழிசெலுத்தல் சரிசெய்தல்கள்",
    "Text Align": "Text Align",
    "Align Left": "இடது சீரமை",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "எழுத்து அளவை சரிசெய்",
    "Highlight Title": "தலைப்பை முன்னிலைப்படுத்து",
    "Highlight Links": "இணைப்புகளை முன்னிலைப்படுத்து",
    "Readable Font": "படிக்கக்கூடிய எழுத்து",
    "Colour adjustments": "நிற சரிசெய்தல்கள்",
    "Dark Contrast": "கருமை வேறுபாடு",
    "Light Contrast": "வெளிச்ச வேறுபாடு",
    "High Contrast": "உயர் வேறுபாடு",
    "High Saturation": "உயர் செறிவு",
    "Low Saturation": "குறைந்த செறிவு",
    "Monochrome": "ஒற்றை நிறம்",
    "Tools": "கருவிகள்",
    "Reading Guide": "படிப்பு வழிகாட்டி",
    "Big Cursor": "பெரிய கர்சர்",
    "Increase Font Size": "எழுத்து அளவை அதிகரி",
    "Decrease Font Size": "எழுத்து அளவை குறை",
    "Letter Spacing": "எழுத்து இடைவெளி",
    "Line Height": "வரி உயரம்",
    "Font Weight": "எழுத்து தடிமன்",
    "Dyslexia Font": "டிஸ்லெக்ஸியா எழுத்து",
    "Language": "மொழி",
    "Accessibility widget": "அணுகல் மெனுவை திற",
    "Accessibility Profiles": "அணுகல் சுயவிவரங்கள்",
    "Cognitive Disability": "அறிவாற்றல் குறைபாடு",
    "Seizure Safe": "வலிப்பு பாதுகாப்பு",
    "Accessibility statement": "அணுகல் அறிக்கை",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "அனிமேஷன்களை நிறுத்து",
    "Reset all settings": "அமைப்புகளை மீட்டமை",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
